class AtelierNote extends HTMLElement {
  connectedCallback() {
    const canAnimate = this.dataset.animate === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!canAnimate || !('IntersectionObserver' in window)) {
      this.classList.add('atelier-note--visible');
      return;
    }

    this.classList.add('atelier-note--ready');
    this.observer = new IntersectionObserver(([entry]) => {
      if (!entry?.isIntersecting) return;
      this.classList.add('atelier-note--visible');
      this.observer?.disconnect();
    }, { threshold: 0.18 });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('atelier-note')) customElements.define('atelier-note', AtelierNote);
